export function hasHttpStatus(error: unknown, status: number): boolean {
  return (
    typeof error === 'object' && error !== null && 'status' in error && error.status === status
  );
}

/** Vrai quand l'erreur de l'API porte ce code métier (`code` posé par `apiErrorInterceptor`). */
export function hasApiErrorCode(error: unknown, code: string): boolean {
  return typeof error === 'object' && error !== null && 'code' in error && error.code === code;
}

/** Erreur passagère : réseau (0), timeout (408 ou sans statut), 429 ou 5xx. */
export function isTransientHttpError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !('status' in error)) return true;
  const { status } = error;
  if (typeof status !== 'number') return true;
  return status === 0 || status === 408 || status === 429 || status >= 500;
}
